










































































































































































import camelcaseKeysDeep from 'camelcase-keys-deep';
import Enterprise from '@/datatypes/enterprise';
import Subscription from '@/datatypes/subscription';
import User from '@/datatypes/user';
import SubscriptionAssignRequest from '@/datatypes/billing/subscription-assign-request';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import SubscriptionService from '@/services/billing/SubscriptionService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import BillingPriceStructure from '@/components/billing/billing-price-structure.vue';
import MoneyInput from '@/components/money.vue';
import Vue from 'vue';

export default Vue.extend({
  components: {
    SnackbarMessageHandler,
    BillingPriceStructure,
    MoneyInput,
  },
  data: () => ({
    enterprise: new Enterprise({}),
    errorMessage: '',
    enterpriseService: new EnterpriseService(),
    subscriptionService: new SubscriptionService(),
    subscriptionId: '',
    subscription: new Subscription({}),
    subscriptionParams: new SubscriptionAssignRequest({}),
    user: new User({}),
    isAssigningSubscription: false,
    isRejectingExistingSubscription: false,
    rejectingExistingSubscription: new Subscription({}),
  }),

  mounted() {
    this.fetchEnterprise();
  },

  methods: {
    fetchEnterprise(): void {
      this.enterpriseService.getEnterprise(this.$route.params.id).then((response) => {
        this.enterprise = new Enterprise(camelcaseKeysDeep(response.data));
      });
    },

    search(): void {
      if (this.subscriptionId.trim().length === 0) {
        this.errorMessage = this
          .$i18n
          .t('messages.billing.subscription.typeASubscription')
          .toString();
        return;
      }

      this.subscriptionService.show(this.subscriptionId).then((response) => {
        const serverSubscription = new Subscription(camelcaseKeysDeep(response.data));

        if ((serverSubscription.enterprise.id) || (serverSubscription.status === 'canceled')) {
          this.isRejectingExistingSubscription = true;
          this.rejectingExistingSubscription = serverSubscription;
          return;
        }

        this.subscription = serverSubscription;
        this.setSubscriptionDefaults(this.subscription.billingPrice);
      }).catch((error) => {
        this.errorMessage = error.response.data.message;
      });
    },

    closeRejectedSubscriptionDialog(): void {
      this.isRejectingExistingSubscription = false;
      this.rejectingExistingSubscription = new Subscription({});
    },

    assignSubscription(): void {
      this.subscriptionService.assign(
        this.$route.params.id, this.subscriptionParams,
      ).then(() => {
        this.$router.push(`/businesses/${this.$route.params.id}/subscription`);
      });
    },

    setSubscriptionDefaults(billingPrice): void {
      this.subscriptionParams.enterpriseId = this.enterprise.id;
      this.subscriptionParams.externalBillingPriceId = this.subscription.billingPrice.id;
      this.subscriptionParams.externalSubscriptionId = this.subscription.id;
      this.subscriptionParams.metadata.kind = billingPrice.metadata.kind as number;
      this.subscriptionParams.metadata.quota = billingPrice.metadata.quota;
      this.subscriptionParams.metadata.quotaRenewal = billingPrice
        .metadata
        .quotaRenewal as 'month' | 'year';
      this.subscriptionParams.metadata.smsUnitAmount = billingPrice
        .metadata
        .smsUnitAmount as number;
      this.subscriptionParams.metadata.overageUnitAmount = billingPrice.metadata.overageUnitAmount;
    },

    cancelSubscriptionAssignment(): void {
      this.subscriptionParams = new SubscriptionAssignRequest({});
      this.subscription = new Subscription({});
      this.subscriptionId = '';
    },

    smsUnitAmountChange(value): void {
      this.subscriptionParams.metadata.smsUnitAmount = value;
    },

    overageUnitAmountChange(value): void {
      this.subscriptionParams.metadata.overageUnitAmount = value;
    },
  },

  computed: {
    enterpriseId(): string {
      return this.$route.params.id;
    },
    kinds(): Array<Array<string|number>> {
      return this.user.kindHash.filter(
        (item) => item.subscription === true,
      ).map(
        (item) => [item.kind, item.name],
      );
    },
    payg(): boolean {
      if (!this.subscription.billingPrice) return false;

      return this.subscription.billingPrice.payg();
    },
  },
});
